import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue";
import BaseInput from "@/components/shared/inputs/base/BaseInput.vue";


const __default__ = {
  name: "ButtonInputWithTimer",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  type: {
    type: String,
    default: "text",
  },
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "",
  },
  maxlength: {
    type: Number,
  },
  buttonTitle: {
    type: String,
    default: "",
  },
  value: {
    type: String,
    default: "",
  },
  errorMessage: {
    type: String,
    default: "",
  },
  successMessage: {
    type: String,
    default: "",
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  enableClearText: {
    type: Boolean,
    default: true,
  },
  startTime: {
    type: Number,
    default: 180,
  },
  rules: {
    type: Object,
  },
  required: {
    type: Boolean,
    default: true,
  },
},
  emits: ["update:value", "onClickButton"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const inputValue = computed({
  get(): string {
    return props.value as string;
  },
  set(inputValue: string) {
    emit("update:value", inputValue);
  },
});

// 타이머 관련 기능
const isTimeOut = ref(false);
let intervalTimer = 0;
const remainingTimeSec = ref(props.startTime);
const remainingTimeStr = ref("");
const timerErrorMessage = ref("");

const startTimer = () => {
  resetTimer();
  countDown();
  intervalTimer = window.setInterval(countDown, 1000);
};

const stopTimer = () => {
  remainingTimeStr.value = "";
  window.clearInterval(intervalTimer);
};

const resetTimer = () => {
  isTimeOut.value = false;
  timerErrorMessage.value = "";
  remainingTimeSec.value = props.startTime;
  window.clearInterval(intervalTimer);
};

const countDown = () => {
  remainingTimeSec.value -= 1;
  remainingTimeStr.value = formattedTime(remainingTimeSec.value);
  if (remainingTimeSec.value === 0) {
    isTimeOut.value = true;
    inputValue.value = "";
    timerErrorMessage.value = `${props.label}를 다시 요청하세요.`;
    stopTimer();
  }
};

const formattedTime = (time: number) => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  if (minutes === 0 && seconds === 0) {
    return "시간만료";
  } else {
    return minutes === 0 ? `${seconds}초` : `${minutes}분 ${seconds}초`;
  }
};

__expose({
  startTimer,
  stopTimer,
});

const __returned__ = { props, emit, inputValue, isTimeOut, get intervalTimer() { return intervalTimer }, set intervalTimer(v) { intervalTimer = v }, remainingTimeSec, remainingTimeStr, timerErrorMessage, startTimer, stopTimer, resetTimer, countDown, formattedTime, BaseInput }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})